import styled from "styled-components";

export const TeamSelectionContainer = styled.div`
    align-items: start;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;

export const TeamBar = styled.div`
    border-radius: 4px;
    color: #FFFFFF;
    transition: 0.3s;
    transition-timing-function: ease-out;
    width: 100%;
`;

export const ExpandedContent = styled.div`
    align-items: center;
    display: flex;
    gap: 21px;
    flex-wrap: wrap;
    justify-content: center;
    overflow: hidden;
    padding: 16px;
`;

export const TeamDisplay = styled.div`
    box-sizing: border-box;
    height: 36px;
    width: 36px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        transform: scale(1.1);
    }

    .active {
        border: 3px solid rgba(255,255,255,0.67);
        box-sizing: border-box;
        border-radius: 50%;
    }

    img {
        border-radius: 50%;
        cursor: pointer;
        height: 100%;
        width: 100%;
        transition: all 0.2s ease;
    }
`;